/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@getgrover/ui';
import Link from 'ggApp/shared/containers/FrontshopLink';

import {
    Wrapper,
    ContentWrap,
    Content,
    Header,
    Body,
    Banner,
    CtaWrapper,
    RedCTAButton,
} from './styled';

export class CampaignsWidget extends React.PureComponent {
    handleCtaCLick = () => {
        const { onClickCTA } = this.props;
        onClickCTA();
    };

    renderCta() {
        const {
            campaignBannerContent: { cta, ctaColor },
            clickClassName,
        } = this.props;
        if (!cta) return null;
        return (
            <Link
                className={clickClassName}
                external={!cta.internal}
                target="_self"
                to={cta.url}
                onClick={this.handleCtaCLick}
            >
                <CtaWrapper>
                    {ctaColor === 'White (outlined)' ? (
                        <ButtonV2 color="white" outlined>
                            {cta.label}
                        </ButtonV2>
                    ) : ctaColor === 'Grey' ? (
                        <ButtonV2>{cta.label}</ButtonV2>
                    ) : (
                        <RedCTAButton color="red">{cta.label}</RedCTAButton>
                    )}
                </CtaWrapper>
            </Link>
        );
    }

    render() {
        const {
            campaignBannerContent: { title, text, textColor },
            className,
            bannerImageUrl,
        } = this.props;
        return (
            <Wrapper className={className}>
                <Banner
                    imgUrls={bannerImageUrl}
                    src={bannerImageUrl}
                    lazy={false}
                    backgroundImage={bannerImageUrl}
                />
                <ContentWrap>
                    <Content>
                        <Header textColor={textColor}>{title}</Header>
                        <Body textColor={textColor} html={text} />
                        {this.renderCta()}
                    </Content>
                </ContentWrap>
            </Wrapper>
        );
    }
}

CampaignsWidget.propTypes = {
    className: PropTypes.string,
    clickClassName: PropTypes.string,
    bannerImageUrl: PropTypes.string,
    campaignBannerContent: PropTypes.shape({
        cta: PropTypes.shape({
            internal: PropTypes.bool,
            link: PropTypes.string,
            text: PropTypes.string,
        }),
        title: PropTypes.string,
        text: PropTypes.string,
        image: PropTypes.object,
    }).isRequired,
    onClickCTA: PropTypes.func,
};

CampaignsWidget.defaultProps = {
    className: '',
    clickClassName: '',
    bannerImageUrl: '',
    onClickCTA: () => null,
};
